import { Card, Space, Tag } from "antd"

const DownloadCardWrapper = ({ children, tagMessage, title, description, color }) => {
  return (
    <Card hoverable>
      <Space direction="vertical" size={'large'} style={{ width: '100%' }}>
        <Space direction='vertical'>
          <Tag color={color}>{tagMessage}</Tag>
          <Card.Meta title={title} description={description} />
        </Space>
        {children}
      </Space>
    </Card>
  )
}

export default DownloadCardWrapper
